import React from "react";
const themes = {
    primary: 'theme-primary',
    secondary: 'theme-secondary',
    tertiary: 'theme-tertiary',
}
export const ThemeContext = React.createContext('');